import { useRef, useState } from "react";
import { useLocation } from "react-router";

export function BackToTopButton() {
    const [visible, setVisible] = useState(false);
    const [hasHitBottomOfPage, setHasHitBottomOfPage] = useState(false);
    const scrollAmountRequired: number = 300;
    const buttonRef = useRef<HTMLButtonElement>(null);
    const location = useLocation();

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > scrollAmountRequired) {
            setVisible(true);
        } else if (scrolled <= scrollAmountRequired) {
            setVisible(false);
        }

        if (location.pathname == '/PositionDetails') { 
            // +50 is a fudge value to trigger this before we hit the bottom of the page to stop overlap with apply/register button 
            if (!hasHitBottomOfPage && (window.innerHeight + Math.round(window.scrollY)) + 50 >= document.body.offsetHeight) {
                // you're at the bottom of the page
                setHasHitBottomOfPage(true);
                buttonRef.current.classList.add("btn-backtotop-bottomed");
            } else if (hasHitBottomOfPage && (window.innerHeight + Math.round(window.scrollY)) + 50 < document.body.offsetHeight) {
                setHasHitBottomOfPage(false);
                buttonRef.current.classList.remove("btn-backtotop-bottomed");
            }
        }
        else
        {
            if(!buttonRef.current.classList.contains("btn-backtotop-bottomed"))
                buttonRef.current.classList.add("btn-backtotop-bottomed");
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    window.addEventListener("scroll", toggleVisible);

    return (
        <>
            <button ref={buttonRef} className="btn btn-backtotop" onClick={scrollToTop} style={{ display: visible ? "inline" : "none" }}><i className="fa-solid text-center fa-arrow-up position-absolute top-50 start-50 translate-middle"></i></button>
        </>
    );
}